import classNames from 'classnames';

type NotificationsCountProps = {
  count: number;
  className?: string;
};

export const NotificationsCount = ({ count, className }: NotificationsCountProps) => {
  return (
    <div
      className={classNames(
        'w-6 h-6 bg-negative rounded-full text-center font-semibold text-xs leading-24 text-white',
        className,
      )}
    >
      {count}
    </div>
  );
};
